// extracted by mini-css-extract-plugin
module.exports = {"pagination":"_403f0a60","navLeft":"f71a56f2","container":"_1b46732b","navi":"_1c94c51c","navilink":"_19668c3f","htmlAstWrapper":"_0a8ecd0d"};